import Parse from 'parse'

Parse.serverURL = process.env.VUE_APP_PARSE_URL

Parse.initialize(
  process.env.VUE_APP_APPLICATION_ID,
  process.env.VUE_APP_JAVASCRIPT_KEY
)
